import React, { useState } from "react";
import "./Daohan.css";

function Daohan() {
  const [form, setForm] = useState({
    nganHang: "",
    soTien: "",
    chuTaiKhoan: "",
    soDienThoai: "",
  });

  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    let v = value;

    if (id === "soTien") {
      v = v.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    if (id === "chuTaiKhoan") {
      v = v.replace(/[^a-zA-ZÀ-ỹ\s]/g, "");
    }

    if (id === "soDienThoai") {
      v = v.replace(/\D/g, "").slice(0, 10);
    }

    setForm((prev) => ({ ...prev, [id]: v }));
  };

  const validate = () => {
    const errs = {};

    if (!form.nganHang) errs.nganHang = "Vui lòng chọn ngân hàng.";

    const soTienNumber = Number(form.soTien.replace(/\s/g, ""));
    if (!soTienNumber || soTienNumber <= 0) errs.soTien = "Số tiền không hợp lệ.";

    if (!form.chuTaiKhoan.trim()) errs.chuTaiKhoan = "Vui lòng nhập họ tên hợp lệ.";

    if (!/^\d{10}$/.test(form.soDienThoai)) {
      errs.soDienThoai = "Số điện thoại phải gồm đúng 10 số.";
    }

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);

    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    const payload = {
      action: "form_dang_ky_daohan",
      nganHang: form.nganHang,
      soTien: form.soTien,
      chuTaiKhoan: form.chuTaiKhoan.trim(),
      soDienThoai: `+84${form.soDienThoai.slice(1)}`,
    };

    try {
      const res = await fetch("/api/submit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.ok) {
        window.location.href = "/creditdao";
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <section className="section3">
        <div id="check" className="content3">
          <form
            className="card border-0 shadow-sm p-3 register-card"
            noValidate
            onSubmit={handleSubmit}
          >
            <h2 className="py-3 text-center" id="html1">
              Phiếu Đăng Ký Đáo Hạn
            </h2>

            {/* Ngân hàng */}
            <div className="mb-3">
              <label htmlFor="nganHang" className="form-label">Ngân hàng</label>
              <select
                id="nganHang"
                className={`form-select ${validated && errors.nganHang ? "is-invalid" : ""}`}
                value={form.nganHang}
                onChange={handleChange}
              >
                <option value="">Chọn ngân hàng</option>
                <option value="Agribank">Agribank</option>
                <option value="Vietcombank">Vietcombank</option>
                <option value="VietinBank">VietinBank</option>
                <option value="BIDV">BIDV</option>
                <option value="ACB">ACB</option>
                <option value="AB BANK">AB BANK</option>
                <option value="BAC A BANK">BAC A BANK</option>
                <option value="Baovietbank">Baovietbank</option>
                <option value="BVBank">BVBank</option>
                <option value="HDBank">HDBank</option>
                <option value="MSB">MSB</option>
                <option value="MB">MB Bank</option>
                <option value="Nam A Bank">Nam A Bank</option>
                <option value="OCB">OCB</option>
                <option value="Sacombank">Sacombank</option>
                <option value="SCB">SCB</option>
                <option value="Saigonbank">Saigonbank</option>
                <option value="Techcombank">Techcombank</option>
                <option value="TPBank">TPBank</option>
                <option value="VIB">VIB</option>
                <option value="VPBank">VPBank</option>
                <option value="Eximbank">Eximbank</option>
                <option value="PVcomBank">PVcomBank</option>
                <option value="PG Bank">PG Bank</option>
                <option value="Kienlongbank">Kienlongbank</option>
                <option value="LPBank">LPBank</option>
                <option value="Liobank">Lio Bank</option>
              </select>
              {validated && errors.nganHang && (
                <div className="invalid-feedback d-block">{errors.nganHang}</div>
              )}
            </div>

            {/* Số điện thoại */}
            <div className="mb-3">
              <label htmlFor="soDienThoai" className="form-label">Số điện thoại</label>
              <div className="input-group">
                <span className="input-group-text">+84</span>
                <input
                  type="text"
                  id="soDienThoai"
                  className={`form-control ${validated && errors.soDienThoai ? "is-invalid" : ""}`}
                  inputMode="numeric"
                  placeholder="Nhập số điện thoại"
                  value={form.soDienThoai}
                  onChange={handleChange}
                />
              </div>
              {validated && errors.soDienThoai && (
                <div className="invalid-feedback d-block">{errors.soDienThoai}</div>
              )}
            </div>

            {/* Số tiền */}
            <div className="mb-3">
              <label htmlFor="soTien" className="form-label">Số tiền muốn đáo</label>
              <div className="input-group">
                <input
                  type="text"
                  id="soTien"
                  className={`form-control ${validated && errors.soTien ? "is-invalid" : ""}`}
                  inputMode="numeric"
                  placeholder="Nhập số tiền"
                  value={form.soTien}
                  onChange={handleChange}
                />
                <span className="input-group-text">đ</span>
              </div>
              {validated && errors.soTien && (
                <div className="invalid-feedback d-block">{errors.soTien}</div>
              )}
            </div>

            {/* Chủ tài khoản */}
            <div className="mb-3">
              <label htmlFor="chuTaiKhoan" className="form-label">Chủ tài khoản</label>
              <input
                type="text"
                id="chuTaiKhoan"
                className={`form-control ${validated && errors.chuTaiKhoan ? "is-invalid" : ""}`}
                placeholder="Họ và tên"
                value={form.chuTaiKhoan}
                onChange={handleChange}
              />
              {validated && errors.chuTaiKhoan && (
                <div className="invalid-feedback d-block">{errors.chuTaiKhoan}</div>
              )}
            </div>

            <div className="text-center">
              <button type="submit" className="btn hero-btn w-100 fw-bold mt-2">
                Xác nhận
              </button>
            </div>

            <div className="py-4 d">
            <div className="d-flex gap-1">
              <img style={{width:'20px',height:'20px',}} src="/security.svg" alt="security" />
              <p className='fw-bold' style={{color:'#138626'}}>Tất cả dữ liệu được bảo vệ.</p>
            </div>
          </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Daohan;